import {useCallback, useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import { useMetaTags } from '../../services/useMetaTags';
import './instruction.scss';

const MODULES = [
    {
        id: 'module1',
        number: 'Модуль 1',
        navName: 'Стартова сторінка: наша місія, мета і можливості',
        title: 'Стартова сторінка: наша місія, мета і можливості',
        videoUrl: 'https://www.youtube.com/embed/ddXsfQALavg?rel=0',
        text: 'Що таке «Аксемедін» і які можливості він надає? Відповіді на ці та інші запитання представлені у відеоролику.',
    },
    {
        id: 'module2',
        number: 'Модуль 2',
        navName: 'Реєстрація',
        title: 'Реєстрація',
        videoUrl: 'https://www.youtube.com/embed/WR9OjatmXqA?rel=0',
        text: 'Щоб почати працювати з платформою, вам необхідно пройти реєстрацію. Як саме це зробити, ви дізнаєтеся, переглянувши відеоролик.',
    },
    {
        id: 'module3',
        number: 'Модуль 3',
        navName: 'Головна сторінка, портфоліо (+бали)',
        title: 'Головна сторінка, портфоліо (+бали)',
        videoUrl: 'https://www.youtube.com/embed/ahPoUvMLi5M?rel=0',
        text: 'Вітаємо з успішною реєстрацією! Тепер, відвідуючи платформу «Аксемедін», ви будете потрапляти на головну сторінку. Що є на головній сторінці, як заповнити портфоліо і навіщо отримувати бали? Відповіді на ці та інші запитання дивіться у відеоролику.',
    },
    {
        id: 'module4',
        number: 'Модуль 4',
        navName: 'Опитування',
        title: 'Опитування',
        videoUrl: 'https://www.youtube.com/embed/daNIpsuCyuA?rel=0',
        text: 'Однією зі складових частин платформи є розділ «Опитування». Як саме з ним працювати, ви дізнаєтеся, переглянувши відеоролик.',
    },
    {
        id: 'module5',
        number: 'Модуль 5',
        navName: 'Матеріали',
        title: 'Матеріали',
        videoUrl: 'https://www.youtube.com/embed/WZKnLRwU57c?rel=0',
        text: 'У розділі «Матеріали» ми розмістили найкращі статті та дослідження лідерів думок, міжнародні гайдлайни, локальні протоколи та багато іншої корисної інформації для лікарів. Для ефективної роботи з розділом пропонуємо вам ознайомитися з відеороликом.',
    },
    {
        id: 'module6',
        number: 'Модуль 6',
        navName: 'Навчальні курси',
        title: 'Навчальні курси',
        videoUrl: 'https://www.youtube.com/embed/ODKcmfhO15Q?rel=0',
        text: 'Для безперервного професійного розвитку лікарів платформа «Аксемедін» пропонує навчальні відеокурси, створені за новітньою системою microlearning. Детальніше про цей розділ ви дізнаєтеся, переглянувши відеоролик.',
    },
    {
        id: 'module7',
        number: 'Модуль 7',
        navName: 'Заходи',
        title: 'Заходи',
        videoUrl: 'https://www.youtube.com/embed/FS2XeQKBEak?rel=0',
        text: 'Розділ «Події» дає можливість кожному лікарю бути в курсі заходів у галузі та планувати свою присутність на медичних конгресах, семінарах, симпозіумах, виставках. Як саме ефективно працювати з цим розділом, ви дізнаєтеся, переглянувши відеоролик.',
    },
    {
        id: 'module8',
        number: 'Модуль 8',
        navName: 'Організації',
        title: 'Організації',
        videoUrl: 'https://www.youtube.com/embed/Tjmb1XlOuk8?rel=0',
        text: 'Однією зі складових частин платформи є розділ «Організації». Як саме з ним працювати, ви дізнаєтеся, переглянувши відеоролик.',
    },
    {
        id: 'module9',
        number: 'Модуль 9',
        navName: 'AR',
        title: 'AR',
        videoUrl: 'https://www.youtube.com/embed/w1s9dHgm6sA?rel=0',
        text: 'Платформа «Аксемедін» підтримує та впроваджує у свою роботу новітні технології. Саме тому ми запустили програму для вашого смартфону з доповненою реальністю (augmented reality, AR). Детальніше про програму ви дізнаєтеся, переглянувши відеоролик.',
    },
];

export default function Instruction() {
    const {t} = useTranslation();
    const [activeModuleId, setActiveModuleId] = useState(MODULES[0].id);
    const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
    const [navPosition, setNavPosition] = useState({fixed: false, toBottom: false, left: 0});
    const pageRef = useRef(null);
    const navRef = useRef(null);

    useMetaTags({
        title: `Інструкція користувача | ${t('app.title')}`,
        description: t('app.description'),
        metas: [{name: 'keywords', content: t('app.keywords')}],
    });

    const updateNavPosition = useCallback(() => {
        const pageElement = pageRef.current;
        const navElement = navRef.current;

        if (!pageElement || !navElement) {
            return;
        }

        if (window.innerWidth <= 1200) {
            setNavPosition((previous) => (
                previous.fixed || previous.toBottom || previous.left
                    ? {fixed: false, toBottom: false, left: 0}
                    : previous
            ));
            return;
        }

        const pageRect = pageElement.getBoundingClientRect();
        const pageTop = pageRect.top + window.scrollY;
        const pageHeight = pageElement.offsetHeight;
        const navHeight = navElement.offsetHeight;
        const scrollDistance = window.scrollY;

        const fixed = scrollDistance > pageTop - 40;
        const toBottom = scrollDistance > pageTop + pageHeight - navHeight - 80;
        const left = Math.round(pageRect.left + window.scrollX);

        setNavPosition((previous) => (
            previous.fixed === fixed && previous.toBottom === toBottom && previous.left === left
                ? previous
                : {fixed, toBottom, left}
        ));
    }, []);

    useEffect(() => {
        const setActiveOnScroll = () => {
            const scrollPosition = window.scrollY;
            let currentId = MODULES[0].id;

            const moduleBoxes = document.querySelectorAll('.instruction-spa-module-box');
            moduleBoxes.forEach((moduleElement) => {
                const moduleTop = moduleElement.getBoundingClientRect().top + window.scrollY;
                const moduleId = moduleElement.getAttribute('data-module-id');
                if (moduleId && moduleTop <= scrollPosition) {
                    currentId = moduleId;
                }
            });

            setActiveModuleId(currentId);
        };

        const onScroll = () => {
            setActiveOnScroll();
            updateNavPosition();
        };

        setActiveOnScroll();
        updateNavPosition();
        window.addEventListener('scroll', onScroll, {passive: true});
        window.addEventListener('resize', onScroll);

        return () => {
            window.removeEventListener('scroll', onScroll);
            window.removeEventListener('resize', onScroll);
        };
    }, [updateNavPosition]);

    useEffect(() => {
        const closeOnWideViewport = () => {
            if (window.innerWidth > 1200) {
                setIsMobileNavOpen(false);
            }

            updateNavPosition();
        };

        window.addEventListener('resize', closeOnWideViewport);
        return () => window.removeEventListener('resize', closeOnWideViewport);
    }, [updateNavPosition]);

    const scrollToModule = useCallback((moduleId) => {
        const anchor = document.getElementById(moduleId);
        if (!anchor) {
            return;
        }

        const top = anchor.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({top, behavior: 'smooth'});
    }, []);

    const onNavClick = useCallback((event, moduleId) => {
        event.preventDefault();
        setActiveModuleId(moduleId);
        scrollToModule(moduleId);
        setIsMobileNavOpen(false);
    }, [scrollToModule]);

    const navClassName = [
        'instruction-spa-nav',
        navPosition.fixed ? 'fixed' : '',
        navPosition.toBottom ? 'to-bottom' : '',
        isMobileNavOpen ? 'active' : '',
    ].filter(Boolean).join(' ');

    const navInlineStyle = navPosition.fixed && !navPosition.toBottom
        ? {left: `${navPosition.left}px`}
        : undefined;

    return (
        <div className="instruction-spa">
            <section className="instruction-spa-section">
                <div className="container">
                    <div className="instruction-spa-page" ref={pageRef}>
                        <div className="instruction-spa-sidebar-col">
                            <h1 className="instruction-spa-page-title">Інструкція користувача</h1>
                            <div className={navClassName} style={navInlineStyle} ref={navRef}>
                                {MODULES.map((module) => (
                                    <a
                                        href={`#${module.id}`}
                                        key={module.id}
                                        className={activeModuleId === module.id ? 'active' : ''}
                                        onClick={(event) => onNavClick(event, module.id)}>
                                        <div className="instruction-spa-nav-name-global">{module.number}</div>
                                        <div className="instruction-spa-nav-name">{module.navName}</div>
                                    </a>
                                ))}
                            </div>

                            <button
                                type="button"
                                className={`instruction-spa-nav-btn-mob ${isMobileNavOpen ? 'active' : ''}`}
                                onClick={() => setIsMobileNavOpen((value) => !value)}
                                aria-label="Toggle instruction navigation">
                                <span />
                                <span />
                                <span />
                            </button>
                        </div>

                        <div className="instruction-spa-content-col">
                            {MODULES.map((module, index) => (
                                <div className="instruction-spa-module-box" key={module.id} data-module-id={module.id}>
                                    <div id={module.id} className="instruction-spa-module-anchor" />
                                    <p className="instruction-spa-module-number">{module.number}</p>
                                    <p className="instruction-spa-module-title">{module.title}</p>
                                    <div className="instruction-spa-module-video">
                                        <iframe
                                            width="100%"
                                            height="100%"
                                            src={module.videoUrl}
                                            title={`${module.number}: ${module.title}`}
                                            frameBorder="0"
                                            allow="autoplay; encrypted-media"
                                            allowFullScreen />
                                    </div>
                                    <div className="instruction-spa-module-text">{module.text}</div>
                                    {index === MODULES.length - 1 && <div className="instruction-spa-module-last-spacer" />}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
